import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Aplicas siempre la misma tensión sin saber si es la correcta para ese objetivo', 'No sabes con certeza cuándo usar corte en Y versus corte en I versus corte en Abanico', 'Tus pacientes te preguntan para qué sirve la cinta y tu explicación no es tan sólida como quisieras', 'Has tenido pacientes con irritación cutánea o cinta que se despega a las pocas horas', 'No tienes un protocolo claro para edema, para lumbalgia, para hombro, para rodilla', 'Sientes que podrías sacarle mucho más partido a esta técnica si tuvieras una guía estructurada'];
  return <section className="py-16 px-4 bg-navy-800" data-id="element-195">
      <div className="max-w-3xl mx-auto" data-id="element-196">
        <FadeIn data-id="element-197">
          <h2 className="text-sm tracking-[0.2em] text-gold-500 font-bold mb-8 text-center uppercase font-body" data-id="element-198">
            El Problema Que Nadie Te Dice
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg leading-relaxed text-cream-200 mb-16" data-id="element-199">
          <FadeIn delay={0.1} data-id="element-200">
            <p data-id="element-201">
              El Kinesiotaping es una de las técnicas más visibles del mundo de
              la salud y el deporte.
            </p>
            <p className="mt-4" data-id="element-202">
              Está en los Juegos Olímpicos. Está en los vestuarios de la NBA.
              Está en las clínicas de fisioterapia más reconocidas del mundo.
            </p>
            <p className="mt-4" data-id="element-203">Y sin embargo...</p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-204">
            <p className="text-2xl font-heading text-cream-100 my-8 border-l-4 border-gold-500 pl-6 py-2" data-id="element-205">
              <strong data-id="element-206">
                La mayoría de los profesionales que la usan la aplican mal.
              </strong>
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-207">
            <p data-id="element-208">No por falta de inteligencia.</p>
            <p data-id="element-209">No por falta de voluntad.</p>
            <p className="mt-4" data-id="element-210">
              Sino porque la información disponible está fragmentada,
              descontextualizada y en muchos casos directamente equivocada.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="pl-6 border-l border-navy-700 space-y-4 my-8 text-cream-200/80 italic" data-id="element-211">
            <p data-id="element-212">Videos de YouTube que no explican el porqué.</p>
            <p data-id="element-213">Cursos costosos que enseñan solo los movimientos básicos.</p>
            <p data-id="element-214">
              Artículos genéricos que no traducen la ciencia a la práctica real.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-215">
            <p data-id="element-216">El resultado es siempre el mismo:</p>
            <p className="text-xl text-gold-400 mt-2 font-medium" data-id="element-217">
              Un profesional que aplica la cinta con dudas, sin criterio clínico
              definido, esperando que funcione por inercia.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} className="mt-14" data-id="element-218">
          <h3 className="text-2xl md:text-3xl font-heading text-center mb-10 text-cream-100" data-id="element-219">
            ¿Te identificas con alguna de estas situaciones?
          </h3>

          <div className="space-y-4 mb-12" data-id="element-220">
            {painPoints.map((point, index) => <FadeIn key={index} delay={0.1 * index} direction="left" data-id="element-221">
                <div className="flex items-start bg-navy-900/50 p-4 rounded-sm border border-navy-700/50" data-id="element-222">
                  <XCircle className="w-6 h-6 text-red-400/80 mr-4 flex-shrink-0 mt-0.5" data-id="element-223" />
                  <p className="text-cream-200" data-id="element-224">{point}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn data-id="element-225">
            <p className="text-center text-xl text-gold-400 italic font-heading" data-id="element-226">
              Si dijiste sí a cualquiera de estas situaciones, lo que estás a
              punto de leer fue escrito exactamente para ti.
            </p>
          </FadeIn>
        </FadeIn>

        <FadeIn delay={0.2} className="mt-14" data-id="element-227">
          <h2 className="text-sm tracking-[0.2em] text-gold-500 font-bold mb-8 text-center uppercase font-body" data-id="element-228">
            La Raíz Del Problema
          </h2>

          <div className="space-y-6 text-lg text-cream-200" data-id="element-229">
            <p data-id="element-230">No es que el Kinesiotaping no funcione.</p>
            <p className="text-2xl font-heading text-cream-100" data-id="element-231">
              <strong data-id="element-232">
                El problema es que nadie te enseñó el sistema completo.
              </strong>
            </p>

            <ul className="space-y-3 my-8 pl-6 border-l-2 border-gold-500/30" data-id="element-233">
              <li data-id="element-234">La tensión correcta según el objetivo.</li>
              <li data-id="element-235">La dirección correcta según el tejido.</li>
              <li data-id="element-236">El corte correcto según la anatomía.</li>
              <li data-id="element-237">El protocolo correcto según la patología.</li>
            </ul>

            <p className="text-xl text-red-300/90 font-medium" data-id="element-238">
              Sin ese sistema, la cinta es solo decoración de colores.
            </p>
            <p className="text-xl text-gold-400 font-medium mt-4" data-id="element-239">
              Con ese sistema, es una herramienta clínica que transforma la
              experiencia de tus pacientes y el valor percibido de tu práctica
              profesional.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}